<div class="nri-page">

  <!-- HERO -->
<section class="nri-section nri-hero max-w-[1440px] mx-auto px-6 pt-16 md:pt-24 sm:pt-32 pb-16 sm:pb-24">

  <div class="grid lg:grid-cols-2 gap-10 lg:gap-20 items-center">

    <!-- LEFT -->
    <div class="order-1 lg:order-1 pt-2">

      <span class="inline-flex items-center px-4 py-2 rounded-full bg-[#F3EDFF] text-[#8C52FF] text-xs tracking-[2px] uppercase">
        Global Indians Hub
      </span>

      <h1 class="mt-5 text-[42px] leading-[0.95] tracking-tight text-black font-light sm:text-[56px] lg:text-[84px]">

        Your Bengaluru Home,

        <br>

        <span class="nri-hero-accent">
          Wherever
        </span>

        You Are.

      </h1>

      <p class="mt-6 text-[18px] sm:text-xl text-[#595959] max-w-xl leading-relaxed">

        Helping NRIs and Global Indians discover luxury homes,
        evaluate opportunities, and buy with confidence from
        anywhere in the world.

      </p>

      <div class="mt-8 flex gap-3">

        <a routerLink="/search" class="nri-properties-cta theme-btn1 font-semibold text-white transition-transform active:scale-95">
          Explore Properties <span aria-hidden="true">↗</span>
        </a>

        <button (click)="openExpertModal()" 
          class="px-8 py-4 rounded-full border border-gray-300 hover:bg-black text-[12px] md:text-sm  hover:text-white transition-all duration-300">

          Talk To An Advisor

        </button>

      </div>

      <!-- TRUST NUMBERS -->

      <div class="mt-8 grid grid-cols-3 gap-4">

        <div>
            <h3 class="text-xl sm:text-2xl font-semibold">
                1400+
            </h3>
            <p class="text-xs sm:text-sm text-gray-500">
                Families
            </p>
        </div>

        <div>
            <h3 class="text-xl sm:text-2xl font-semibold">
                2014
            </h3>
            <p class="text-xs sm:text-sm text-gray-500">
                Since
            </p>
        </div>

        <div>
            <h3 class="text-xl sm:text-2xl font-semibold">
                RERA
            </h3>
            <p class="text-xs sm:text-sm text-gray-500">
                Verified
            </p>
        </div>

      </div>

    </div>

    <!-- RIGHT -->

    <div class="order-2 lg:order-2 mt-8 lg:mt-0">

      <div
        class="relative rounded-[32px] overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.15)]">

        <img
          src="assets/img/b_sky.png"
          alt="NRI Bengaluru Luxury Homes"
          class="w-full h-[380px] sm:h-[420px] lg:h-[650px] object-cover">

        <div
          class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent">
        </div>

        <!-- COUNTRIES -->

        <div class="absolute top-4 left-4 right-4">

          <div class="bg-white/85 backdrop-blur-md rounded-2xl px-4 py-3">

            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <span class="text-sm text-black">
                    Serving NRIs Across
                </span>

                <div class="flex gap-2 text-xl">
                    🇺🇸 🇬🇧 🇦🇪 🇸🇬 🇨🇦 🇦🇺
                </div>
            </div>

          </div>

        </div>

        <!-- BOTTOM CARD -->

        <div class="absolute bottom-5 left-5 right-5">

          <div
            class="bg-[#ffffff]/20 mt-10 rounded-2xl py-4 px-8 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[5px] border border-[#ffffff]/30">

            <div class="flex items-center justify-between gap-4">

              <div>

                <p
                  class="text-[10px] uppercase tracking-[2px] text-white">

                  Featured Market

                </p>

                <h3 class="text-lg sm:text-2xl text-white mt-1">
                  Bengaluru
                </h3>

              </div>

              <div class="text-right">

                <p
                  class="text-[10px] uppercase tracking-[2px] text-white">

                  Luxury Price Growth

                </p>

                <h3 class="text-2xl text-[#fff] mt-1">
                  +24%
                </h3>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

<!-- TRUST SECTION -->
<section class="nri-section nri-trust py-20 bg-white">

  <div class="max-w-[1440px] mx-auto px-6">

    <div class="text-center max-w-4xl mx-auto">

      <p class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">

        TRUSTED BY GLOBAL INDIANS

      </p>

      <!-- <h2 class="mt-4 text-4xl md:text-5xl leading-tight text-black">

        Helping leaders of leading companies
        find their Bengaluru home

      </h2> -->
      <h2 class="mt-4 text-4xl md:text-5xl leading-tight text-black">

        From founders and CXOs to technology leaders and global professionals,
        we help families make confident real estate decisions in Bengaluru

      </h2>

      <!-- <p class="mt-6 text-lg text-[#595959]">

        From founders and CXOs to technology leaders and global professionals,
        we help families make confident real estate decisions in Bengaluru.

      </p> -->

    </div>

    <!-- LOGOS -->

    <div
      class="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">

      @for (logo of logos; track logo) {

        <div
          class="h-[110px]
                 bg-white
                 border border-gray-100
                 rounded-3xl
                 flex items-center justify-center
                 hover:shadow-lg p-2
                 transition-all duration-300 opacity-70 hover:opacity-100">

          <img
            [src]="logo"
            class="max-h-10 w-auto  transition">

        </div>

      }

    </div>

    <!-- TRUST NUMBERS -->

    <div
      class="mt-20 grid md:grid-cols-3 gap-6">

      <div
        class="bg-[#FAF7FF]
               rounded-[28px]
               p-8 text-center">

        <h3 class="text-4xl font-light">
          1400+
        </h3>

        <p class="mt-2 text-gray-600">
          NRI & Global Families Advised
        </p>

      </div>

      <div
        class="bg-[#FAF7FF]
               rounded-[28px]
               p-8 text-center">

        <h3 class="text-4xl font-light">
          10+
        </h3>

        <p class="mt-2 text-gray-600">
          Years of Bengaluru Market Expertise
        </p>

      </div>

      <div
        class="bg-[#FAF7FF]
               rounded-[28px]
               p-8 text-center">

        <h3 class="text-4xl font-light">
          End-to-End
        </h3>

        <p class="mt-2 text-gray-600">
          Advisory & Transaction Support
        </p>

      </div>

    </div>

  </div>

</section>


<!-- WHY BENGALURU -->
<section class="nri-section nri-edge parallax-section w-full relative overflow-hidden text-white py-16 md:py-24 lg:py-32">
  <!-- PARALLAX BACKGROUND -->
  <div class="absolute inset-0 z-0 overflow-hidden">
    <img 
      src="https://images.pexels.com/photos/4497542/pexels-photo-4497542.jpeg"
      class="w-full h-full object-cover scale-110 parallax-img"
    />
  </div>

  <!-- DARK OVERLAY (important for readability) -->
  <div class="absolute inset-0 bg-gradient-to-b from-[#0F1115]/50 via-[#0F1115]/40 to-[#0F1115]/50"></div>

  <!-- SOFT RADIAL GLOW -->
  <div class="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.05),transparent)]"></div>

  <div class="relative max-w-[1440px] mx-auto px-6">

    <!-- HEADER -->

    <div class="max-w-4xl">

      <!-- <p
        class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">

        THE BENGALURU EDGE

      </p> -->

      <h2 class="mt-5 text-4xl md:text-5xl lg:text-7xl leading-tight text-white drop-shadow-[0_4px_20px_rgba(0,0,0,0.5)]">

        Why Global Indians
        choose Bengaluru

      </h2>

    </div>

    <!-- STATS -->
    <div class="mt-16 p-4 rounded-[32px] bg-black/15 backdrop-blur-md border border-white/10">
      <p
        class="mt-2 text-lg pl-6 text-[#ffffff90] max-w-2xl">

        India's technology capital continues to attract
        global talent, long-term investment and families
        planning their future in India.

      </p>
      <div #statsSection 
        class="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">

        @for (stat of stats; track stat.title) {

          <div class="bg-black/25 backdrop-blur-xl border border-white/20 rounded-[28px] p-8 shadow-[0_20px_50px_rgba(0,0,0,0.25)] hover:-translate-y-2 hover:shadow-xl transition-all duration-300">

            <h3
              class="text-6xl font-light text-white">

              @if(stat.suffix === '%') {
                {{ stat.current | number:'1.0-0' }}%
              }

              @if(stat.suffix === 'M') {
                {{ stat.current | number:'1.1-2' }}M
              }

            </h3>

            <h4 class="mt-5 text-lg font-medium text-white">

              {{ stat.title }}

            </h4>

            <p
              class="mt-3 text-sm leading-relaxed text-white/60">

              {{ stat.desc }}

            </p>

          </div>

        }

      </div>
    </div>
    <!-- HIGHLIGHT PANEL -->

    <div
      class="mt-16 rounded-[32px] bg-black/30 backdrop-blur-xl border border-white/10 p-8 md:p-12">

      <div class="grid lg:grid-cols-2 gap-10 items-center">

        <div>

          <h3
            class="text-3xl md:text-4xl leading-tight">

            A city built on
            innovation, opportunity
            and global connectivity.

          </h3>

          <p
            class="mt-5 text-white/70 leading-relaxed">

            With strong office absorption,
            growing luxury housing demand,
            world-class infrastructure and
            a thriving startup ecosystem,
            Bengaluru remains the preferred
            destination for many returning NRIs.

          </p>

        </div>

        <div
          class="grid grid-cols-2 gap-4">

          <div
            class="bg-white/10 rounded-2xl p-5">

            <p class="text-xs uppercase text-white/50">
              Technology Capital
            </p>

            <h4 class="mt-2 text-xl">
              India's Innovation Hub
            </h4>

          </div>

          <div
            class="bg-white/10 rounded-2xl p-5">

            <p class="text-xs uppercase text-white/50">
              Global Workforce
            </p>

            <h4 class="mt-2 text-xl">
              Talent Magnet
            </h4>

          </div>

          <div
            class="bg-white/10 rounded-2xl p-5">

            <p class="text-xs uppercase text-white/50">
              Luxury Housing
            </p>

            <h4 class="mt-2 text-xl">
              Strong Demand
            </h4>

          </div>

          <div
            class="bg-white/10 rounded-2xl p-5">

            <p class="text-xs uppercase text-white/50">
              Airport Connectivity
            </p>

            <h4 class="mt-2 text-xl">
              Global Access
            </h4>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

<!-- EXPLORE BY GOAL -->
<section class="nri-section nri-goals w-full py-28 bg-gradient-to-b from-white-50 to-purple-200">
    <div class="flex gap-4 justify-center w-full mb-12">
        <svg fill="none" class="h-[12px] w-[12px]" viewBox="0 0 11 11"><path d="M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="#8C52FF"></path></svg>
        <svg fill="none" class="h-[12px] w-[12px]" viewBox="0 0 11 11"><path d="M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="#8C52FF"></path></svg>
        <svg fill="none" class="h-[12px] w-[12px]" viewBox="0 0 11 11"><path d="M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="#8C52FF"></path></svg>
    </div>
    <div class="max-w-[1440px] mx-auto px-6">

        <p class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">
            CURATED PATHWAYS
        </p>
        <!-- Heading -->
        <h2 class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight text-black">
            Explore by your goal
        </h2>

        <p class="mt-6 text-lg text-[#595959] max-w-2xl">

            Every NRI buyer has a different reason for buying.
            Start with your objective and we'll help you find
            the right Bengaluru opportunity.

        </p>

        <!-- Cards -->
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
            @for(goal of goals; track goal.title){
            <!-- Card -->
                <div
                    (click)="selectGoal(goal)"
                    class="group relative backdrop-blur-lg rounded-[24px] p-6
                            border border-white/80
                            bg-gradient-to-b from-purple to-gray
                            shadow-[0_10px_30px_rgba(0,0,0,0.08)]
                            hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]
                            hover:-translate-y-2
                            transition-all duration-500
                            cursor-pointer">

                    <!-- Image -->
                    <div class="h-28 rounded-[24px] overflow-hidden relative">

                        <img
                        [src]="goal.image"
                        class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />

                    </div>

                    <!-- Content -->
                    <div class="mt-6">

                        <h3 class="text-xl font-semibold text-gray-900">
                        {{ goal.title }}
                        </h3>

                        <p class="text-gray-600 leading-relaxed mt-3">
                        {{ goal.desc }}
                        </p>

                        <div class="overflow-hidden h-auto sm:max-h-0 opacity-100 sm:opacity-0 transition-all duration-500 ease-out sm:group-hover:max-h-16 sm:group-hover:opacity-100">
                            <p class="text-[12px] text-gray-800 mt-4">
                                {{ goal.desc2 }}
                            </p>
                        </div>

                    </div>

                </div>
            }
        </div>

    </div>
</section>

<!-- MICRO MARKETS -->
<section class="nri-section nri-markets nri-light-panel py-16 md:py-24 lg:py-32 bg-[#0B1220] text-white overflow-hidden">

  <div class="max-w-[1440px] mx-auto px-6">

    <!-- HEADER -->

    <div class="max-w-4xl">

      <p
        class="text-xs uppercase tracking-[3px] font-semibold text-[#A78BFA]">

        LOCATION INTELLIGENCE

      </p>

      <h2
        class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight">

        Bengaluru, decoded by
        micro-market

      </h2>

      <p
        class="mt-6 text-lg text-white/70 max-w-3xl">

        Every neighbourhood offers a different blend of
        lifestyle, investment potential and connectivity.
        Discover which Bengaluru location aligns with your goals.

      </p>

    </div>

    <!-- MARKET SELECTOR -->

    <div
      class="flex gap-3 overflow-x-auto pb-2 scrollbar-hide mt-14">

      @for(market of microMarkets; track market.name){

        <button
          (click)="selectedMarket = market"
          class="px-6 py-3 rounded-full transition-all duration-300"

          [ngClass]="
            selectedMarket.name === market.name
              ? 'nri-tab-active'
              : 'nri-tab'
          ">

          {{ market.name }}

        </button>

      }

    </div>

    <!-- CONTENT -->

    <div
      class="grid lg:grid-cols-[1.2fr_1fr] gap-12 lg:gap-16 items-center mt-14">

      <!-- IMAGE -->

      <div>

        <img
          [src]="selectedMarket.image"
          [alt]="selectedMarket.name"
          class="w-full h-[350px] md:h-[500px] object-cover rounded-[32px]">

      </div>

      <!-- DETAILS -->

      <div>

        <p
          class="text-xs uppercase tracking-[3px] text-[#A78BFA]">

          Featured Location

        </p>

        <h3
          class="mt-4 text-4xl md:text-5xl leading-tight">

          {{ selectedMarket.name }}

        </h3>

        <p
          class="mt-6 text-white/70 leading-relaxed">

          {{ selectedMarket.description }}

        </p>

        <!-- METRICS -->

        <div
          class="grid grid-cols-2 gap-4 mt-10">

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Rental Demand

            </p>

            <h4 class="mt-3 text-xl">
              {{ selectedMarket.rental }}
            </h4>

          </div>

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Airport Access

            </p>

            <h4 class="mt-3 text-xl">
              {{ selectedMarket.airport }}
            </h4>

          </div>

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Family Suitability

            </p>

            <h4 class="mt-3 text-xl">
              {{ selectedMarket.family }}
            </h4>

          </div>

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Investment Outlook

            </p>

            <h4 class="mt-3 text-xl">
              {{ selectedMarket.investment }}
            </h4>

          </div>

        </div>

      </div>

    </div>

    <!-- QUICK COMPARISON -->

    <div
      class="mt-20 grid md:grid-cols-3 gap-6">

      <div
        class="bg-white/5 rounded-[28px] p-8">

        <p
          class="text-xs uppercase tracking-[2px] text-white/50">

          Best For

        </p>

        <h4
          class="mt-4 text-2xl">

          Investment Buyers

        </h4>

        <p
          class="mt-3 text-white/70">

          Whitefield, Hebbal & North Bengaluru

        </p>

      </div>

      <div
        class="bg-white/5 rounded-[28px] p-8">

        <p
          class="text-xs uppercase tracking-[2px] text-white/50">

          Best For

        </p>

        <h4
          class="mt-4 text-2xl">

          Returning Families

        </h4>

        <p
          class="mt-3 text-white/70">

          Indiranagar, Koramangala & Central Bengaluru

        </p>

      </div>

      <div
        class="bg-white/5 rounded-[28px] p-8">

        <p
          class="text-xs uppercase tracking-[2px] text-white/50">

          Best For

        </p>

        <h4
          class="mt-4 text-2xl">

          Airport Connectivity

        </h4>

        <p
          class="mt-3 text-white/70">

          Hebbal & North Bengaluru

        </p>

      </div>

    </div>

  </div>

</section>

<!-- BUYING JOURNEY -->
<section class="nri-section nri-journey py-16 md:py-24 lg:py-32 bg-[#FAF7FF]">

  <div class="max-w-[1440px] mx-auto px-6">

    <!-- HEADER -->

    <div class="text-center max-w-3xl mx-auto">

      <p
        class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">

        OUR PROCESS

      </p>

      <h2
        class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight">

        Buying from abroad,
        beautifully orchestrated

      </h2>

      <p
        class="mt-6 text-lg text-[#595959]">

        A structured, concierge-led experience designed
        for busy professionals living outside India.

      </p>

    </div>

    <!-- TIMELINE -->

    <div
      class="mt-20 relative">

      <!-- DESKTOP LINE -->

      <div
        class="hidden lg:block absolute top-10 left-0 right-0 h-[1px] bg-purple-200">
      </div>

      <div
        class="grid lg:grid-cols-5 gap-8">

        @for(step of steps; track step.id){

          <div class="relative">

            <!-- STEP NUMBER -->

            <div
              class="w-20 h-20 rounded-full bg-white border border-purple-200 shadow-sm flex items-center justify-center mx-auto relative z-10">

              <span
                class="text-[#8C52FF] text-xl font-semibold">

                {{ step.id }}

              </span>

            </div>

            <!-- CONTENT -->

            <div
              class="mt-8 bg-white rounded-[28px] p-6 text-center shadow-sm hover:shadow-lg transition-all duration-300">

              <h3
                class="text-xl font-medium">

                {{ step.title }}

              </h3>

              <p
                class="mt-3 text-sm text-[#595959] leading-relaxed">

                {{ step.desc }}

              </p>

            </div>

          </div>

        }

      </div>

    </div>

    <!-- CTA -->

    <div
      class="mt-20 text-center">

      <a routerLink="/contactus"
        class="theme-btn1 font-semibold py-3 px-10 text-white rounded-full text-[12px] md:text-sm shadow-lg transition-transform active:scale-95 shrink-0">

        Schedule A Consultation

  </a>

    </div>

  </div>

</section>

<!-- RESOURCE CENTER -->
<section id="knowledgeHub" class="nri-section nri-knowledge py-16 md:py-24 lg:py-32 bg-[#FAF7FF]">

  <div class="max-w-[1440px] mx-auto px-6">

    <div class="max-w-3xl">

      <p
        class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">

        KNOWLEDGE HUB

      </p>

      <h2
        class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight">

        Curated reading for
        serious buyers

      </h2>

      <p
        class="mt-6 text-lg text-[#595959]">

        Explore expert guides created specifically for
        NRIs evaluating luxury real estate opportunities
        in Bengaluru.

      </p>

    </div>

    <div
      class="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">

      @for(article of articles; track article.title){

        <div
          (click)="openArticle(article)"
          class="group cursor-pointer bg-white rounded-[32px] overflow-hidden hover:-translate-y-2 hover:shadow-xl transition-all duration-300">

          <img
            [src]="article.image"
            class="h-[180px] md:h-[220px] w-full object-cover group-hover:scale-105 transition duration-700">

          <div class="p-6">

            <span
              class="text-xs uppercase tracking-[2px] text-[#8C52FF]">

              {{ article.category }}

            </span>

            <h3
              class="mt-3 text-xl leading-snug">

              {{ article.title }}

            </h3>

            <p
              class="mt-3 text-[#595959] text-sm">

              {{ article.desc }}

            </p>

            <button
              class="mt-5 text-[#8C52FF] font-medium">

              Read Guide →

            </button>

          </div>

        </div>

      }

    </div>

  </div>

</section>

<!-- COUNTRY INSIGHTS -->
<section class="nri-section nri-countries nri-light-panel py-16 md:py-24 lg:py-32 bg-[#0B1220] text-white">

  <div class="max-w-[1440px] mx-auto px-6">

    <!-- HEADER -->

    <div class="max-w-4xl">

      <p
        class="text-xs uppercase tracking-[3px] font-semibold text-[#A78BFA]">

        GLOBAL BUYER INSIGHTS

      </p>

      <h2
        class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight">

        What buyers from
        your country want

      </h2>

      <p
        class="mt-6 text-lg text-white/70 max-w-3xl">

        Discover how NRIs from different parts of the world
        approach Bengaluru real estate and where they typically invest.

      </p>

    </div>

    <!-- COUNTRY TABS -->

    <div
      class="flex gap-3 overflow-x-auto pb-2 mt-14">

      @for(country of countries; track country.code){

        <button
          (click)="selectedCountry = country"
          class="px-6 py-3 rounded-full transition-all duration-300"

          [ngClass]="
            selectedCountry.code === country.code
            ? 'nri-tab-active'
            : 'nri-tab'
          ">

          {{ country.flag }}
          {{ country.code }}

        </button>

      }

    </div>

    <!-- COUNTRY DETAILS -->

    <div
      class="mt-14 bg-white/5 border border-white/10 rounded-[32px] p-8 md:p-12">

      <div
        class="grid lg:grid-cols-2 gap-12">

        <!-- LEFT -->

        <div>

          <p
            class="text-xs uppercase tracking-[3px] text-[#A78BFA]">

            Buyer Profile

          </p>

          <h3
            class="mt-4 text-4xl">

            {{ selectedCountry.flag }}
            {{ selectedCountry.code }}

          </h3>

          <p
            class="mt-6 text-white/70 leading-relaxed">

            {{ selectedCountry.description }}

          </p>

        </div>

        <!-- RIGHT -->

        <div
          class="grid md:grid-cols-2 gap-4">

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Primary Motivation

            </p>

            <h4 class="mt-3 text-xl">

              {{ selectedCountry.motivation }}

            </h4>

          </div>

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Preferred Locations

            </p>

            <h4 class="mt-3 text-xl">

              {{ selectedCountry.locations }}

            </h4>

          </div>

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Property Type

            </p>

            <h4 class="mt-3 text-xl">

              {{ selectedCountry.propertyType }}

            </h4>

          </div>

          <div
            class="bg-white/5 rounded-2xl p-5">

            <p
              class="text-xs uppercase tracking-[2px] text-white/40">

              Typical Budget

            </p>

            <h4 class="mt-3 text-xl">

              {{ selectedCountry.budget }}

            </h4>

          </div>

        </div>

      </div>

    </div>

    <!-- BUYER PREFERENCES -->

    <div
      class="mt-10 grid md:grid-cols-3 gap-6">

      <div
        class="bg-white/5 rounded-[28px] p-8">

        <h4 class="text-xl">
          Most Preferred Markets
        </h4>

        <p class="mt-4 text-white/70">
          {{ selectedCountry.locations }}
        </p>

      </div>

      <div
        class="bg-white/5 rounded-[28px] p-8">

        <h4 class="text-xl">
          Typical Objective
        </h4>

        <p class="mt-4 text-white/70">
          {{ selectedCountry.motivation }}
        </p>

      </div>

      <div
        class="bg-white/5 rounded-[28px] p-8">

        <h4 class="text-xl">
          Recommended Strategy
        </h4>

        <p class="mt-4 text-white/70">
          Speak with an advisor to shortlist communities
          aligned with your long-term plans.
        </p>

      </div>

    </div>

    <!-- CTA -->

    <div
      class="mt-16 text-center">

      <a routerLink="/contactus"
        class="theme-btn1 font-semibold py-3 px-10 text-white rounded-full text-[12px] md:text-sm shadow-lg transition-transform active:scale-95 shrink-0">

        Get Country-Specific Advice

      </a>

    </div>

  </div>

</section>

<!-- NRI SPECIALISTS -->
<section class="nri-section nri-advisors py-16 md:py-24 lg:py-32 bg-white">

  <div class="max-w-[1440px] mx-auto px-6">

    <!-- HEADER -->

    <div class="text-center max-w-4xl mx-auto">

      <p
        class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">

        YOUR PERSONAL TEAM

      </p>

      <h2
        class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight">

        Meet the people behind
        your Bengaluru journey

      </h2>

      <p
        class="my-6 text-lg text-[#595959]">

        Real estate decisions are personal.
        Our specialists work closely with NRI buyers to
        simplify every step of the process.

      </p>

    </div>

    <!-- ADVISORS -->

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Card -->
      <div class="group relative p-8 rounded-2xl relative flex flex-col justify-between h-full 
                  bg-white/70 backdrop-blur-xl 
                  border border-gray-200 
                  shadow-[0_10px_40px_rgba(0,0,0,0.06)]
                  transition-all duration-500 
                  hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">

        <!-- Content -->
        <p class="text-gray-700 leading-relaxed mb-8 text-sm">
          Suchit brings 14+ years of experience across real estate advisory and home loan expertise, with deep experience in helping clients navigate high-value property decisions. Known for his sharp market understanding and client-first approach, he’s committed to guiding every client with clarity, trust, and results-focused advice.
        </p>

        <!-- Profile -->
        <div class="flex items-center justify-between mt-auto">

          <!-- Name -->
          <div>
            <h3 class="text-lg font-semibold text-gray-900">
              Suchit Nair
            </h3>
            <p class="text-sm text-gray-400">
              Senior Advisor
            </p>
          </div>

          <!-- Image -->
            <div class="relative w-24 h-24 rounded-xl overflow-hidden bg-gray-100 flex items-end justify-center">
    
                <img src="assets/img/suchit.png" 
                    class="h-[90%] object-contain object-bottom scale-110" />

                <div class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white/60 to-transparent"></div>
            </div>

        </div>

      </div>

      <!-- Card -->
      <div class="group relative p-8 rounded-2xl relative flex flex-col justify-between h-full 
                  bg-white/70 backdrop-blur-xl 
                  border border-gray-200 
                  shadow-[0_10px_40px_rgba(0,0,0,0.06)]
                  transition-all duration-500 
                  hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">

        <p class="text-gray-700 leading-relaxed mb-8 text-sm">
          With a background in hotel client management and high-velocity sales, Meher brings warmth, structure, and clarity to every search. She is known for transforming complex requirements into smooth buying journeys.
        </p>

        <div class="flex items-center justify-between mt-auto">

          <div>
            <h3 class="text-lg font-semibold text-gray-900">
              Meher Javiad
            </h3>
            <p class="text-sm text-gray-400">
              Advisor
            </p>
          </div>

          <!-- Image -->
            <div class="relative w-24 h-24 rounded-xl overflow-hidden bg-gray-100 flex items-end justify-center">
    
                <img src="assets/img/meher.png" 
                    class="h-[90%] object-contain object-bottom scale-110" />

                <div class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white/60 to-transparent"></div>
            </div>

        </div>

      </div>

      <!-- Card -->
      <div class="group relative p-8 rounded-2xl relative flex flex-col justify-between h-full 
                  bg-white/70 backdrop-blur-xl 
                  border border-gray-200 
                  shadow-[0_10px_40px_rgba(0,0,0,0.06)]
                  transition-all duration-500 items-between 
                  hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">

        <p class="text-gray-700 leading-relaxed mb-8 text-sm">
          Kevin’s 14-year career across aviation, procurement, and travel operations gives him a uniquely disciplined, solutions-first approach. Clients value his dependability, discretion, and commitment to getting things done.
        </p>

        <div class="flex items-center justify-between mt-auto">

          <div>
            <h3 class="text-lg font-semibold text-gray-900">
              Kevin Irudiaraj
            </h3>
            <p class="text-sm text-gray-400">
              Senior Advisor
            </p>
          </div>

          <!-- Image -->
            <div class="relative w-24 h-24 rounded-xl overflow-hidden bg-gray-100 flex items-end justify-center">
    
                <img src="assets/img/kevin.png" 
                    class="h-[90%] object-contain object-bottom scale-110" />

                <div class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white/60 to-transparent"></div>
            </div>

        </div>

      </div>

    </div>

    <!-- TRUST PANEL -->

    <div
      class="mt-20 rounded-[32px]
             bg-[#0B1220]
             text-white
             p-8 md:p-12">

      <div
        class="grid lg:grid-cols-2 gap-10 items-center">

        <div>

          <h3
            class="text-3xl md:text-4xl leading-tight">

            One relationship.
            Complete accountability.

          </h3>

          <p
            class="mt-5 text-white/70 leading-relaxed">

            From the first consultation through property
            selection, negotiations, documentation and
            transaction support, we remain your single
            point of contact.

          </p>

        </div>

        <div
          class="grid grid-cols-2 gap-4">

          <div
            class="bg-white/10 rounded-2xl p-5">

            <h4 class="text-xl">
              Property Discovery
            </h4>

          </div>

          <div
            class="bg-white/10 rounded-2xl p-5">

            <h4 class="text-xl">
              Virtual Reviews
            </h4>

          </div>

          <div
            class="bg-white/10 rounded-2xl p-5">

            <h4 class="text-xl">
              Documentation
            </h4>

          </div>

          <div
            class="bg-white/10 rounded-2xl p-5">

            <h4 class="text-xl">
              Transaction Support
            </h4>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

<!-- CONSULTATION CTA -->
<section
  class="nri-section nri-consultation nri-light-panel py-16 md:py-24 lg:py-32 bg-gradient-to-br from-[#0B1220] via-[#111827] to-[#1F2937] text-white">

  <div class="max-w-[1440px] mx-auto px-6">

    <div
      class="rounded-[40px]
             border border-white/10
             bg-white/5
             backdrop-blur-sm
             overflow-hidden">

      <div
        class="grid lg:grid-cols-[1.1fr_0.9fr]">

        <!-- LEFT -->

        <div
          class="p-8 md:p-12 lg:p-16">

          <p
            class="text-xs uppercase tracking-[3px] text-[#A78BFA]">

            PRIVATE CONSULTATION

          </p>

          <h2
            class="mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight">

            Let's find your
            Bengaluru home

          </h2>

          <p
            class="mt-6 text-lg text-white/70 max-w-xl">

            Receive a personalised shortlist,
            location recommendations and expert
            guidance tailored to your goals.

          </p>

          <!-- BENEFITS -->

          <div
            class="mt-10 space-y-5">

            <div class="flex items-start gap-4">

              <div
                class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">

                ✓

              </div>

              <div>

                <h4 class="text-lg">
                  Curated Property Shortlist
                </h4>

                <p class="text-white/60 text-sm">
                  Based on your lifestyle and investment goals.
                </p>

              </div>

            </div>

            <div class="flex items-start gap-4">

              <div
                class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">

                ✓

              </div>

              <div>

                <h4 class="text-lg">
                  Micro-Market Guidance
                </h4>

                <p class="text-white/60 text-sm">
                  Understand which Bengaluru locations fit you best.
                </p>

              </div>

            </div>

            <div class="flex items-start gap-4">

              <div
                class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">

                ✓

              </div>

              <div>

                <h4 class="text-lg">
                  End-To-End Advisory
                </h4>

                <p class="text-white/60 text-sm">
                  Support from discovery to documentation.
                </p>

              </div>

            </div>

          </div>

          <!-- TRUST -->

          <div
            class="mt-12 flex flex-wrap gap-8">

            <div>

              <h3 class="text-2xl">
                1400+
              </h3>

              <p class="text-white/60 text-sm">
                Families Advised
              </p>

            </div>

            <div>

              <h3 class="text-2xl">
                10+
              </h3>

              <p class="text-white/60 text-sm">
                Years Experience
              </p>

            </div>

            <div>

              <h3 class="text-2xl">
                Global
              </h3>

              <p class="text-white/60 text-sm">
                NRI Expertise
              </p>

            </div>

          </div>

        </div>

        <!-- RIGHT FORM -->

        <div
          class="bg-white p-8 md:p-12 text-black">

          <h3
            class="text-3xl">

            Schedule a Consultation

          </h3>

          <p
            class="mt-3 text-gray-500">

            Tell us a little about your requirements.

          </p>

          <form [formGroup]="expertForm" (ngSubmit)="submitExpertForm()" class="mt-8 space-y-5">

            <input
              type="text" formControlName="name" aria-label="Full name"
              placeholder="Full Name"
              class="w-full border border-gray-200 rounded-2xl px-5 py-4 focus:outline-none focus:border-[#8C52FF]">

            <input
              type="email" formControlName="email" aria-label="Email address"
              placeholder="Email Address"
              class="w-full border border-gray-200 rounded-2xl px-5 py-4 focus:outline-none focus:border-[#8C52FF]">

            <input
              type="tel" formControlName="mobile" aria-label="Mobile number"
              placeholder="Mobile Number"
              class="w-full border border-gray-200 rounded-2xl px-5 py-4 focus:outline-none focus:border-[#8C52FF]">

            <textarea
              rows="4" formControlName="message" aria-label="Your requirements"
              placeholder="Tell us what you're looking for..." 
              class="w-full border border-gray-200 rounded-2xl px-5 py-4 resize-none focus:outline-none focus:border-[#8C52FF]"></textarea>

            <button
              type="submit"
              class="theme-btn1 font-semibold py-3 px-10 text-white rounded-full text-[12px] md:text-sm shadow-lg transition-transform active:scale-95 shrink-0">

              Get My Personalised Shortlist

            </button>
            @if (isFormSubmitted) { <p role="status" class="text-green-700">Request sent. Our advisor will contact you soon.</p> }
            @if (expertForm.touched && expertForm.invalid) { <p role="alert" class="text-red-700">Please enter your name, a valid email, a 10-digit mobile number and your requirements.</p> }

          </form>

          <!-- SMALL NOTE -->

          <p
            class="mt-5 text-xs text-gray-400 text-center">

            No spam. Your information remains private and confidential.

          </p>

        </div>

      </div>

    </div>

  </div>

</section>

</div>



@if(selectedArticle){
    <div
    class="article-modal-backdrop fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm">

    <div class="article-modal-panel max-w-4xl w-full mx-auto max-h-[90vh] overflow-auto scrollbar-hide bg-white rounded-[8px] shadow-[0_30px_80px_rgba(0,0,0,0.25)] mx-auto my-10">

        <!-- HEADER -->

        <div class="sticky top-0 z-20 bg-white/95 backdrop-blur-md border-b px-8 py-6">

            <div class="flex justify-between items-center gap-2">

                <div>

                  <p
                      class="text-xs uppercase tracking-[2px] text-[#8C52FF]">

                      {{ selectedArticle.category }}

                  </p>

                  <h2
                      class="mt-2 text-3xl">

                      {{ selectedArticle.title }}

                  </h2>

                </div>

                <button
                (click)="closeArticle()"
                class="w-12 h-12 shrink-0 rounded-full bg-gray-100">

                ✕

                </button>

            </div>

        </div>

        <!-- CONTENT -->

        <div class="p-8">

            <img [src]="selectedArticle.image" class="w-full h-[300px] md:h-[100%] object-cover rounded-[24px]">

            <div class="max-w-3xl mx-auto text-[18px] leading-[1.9] text-[#444] mt-10">

                <div [innerHTML]="selectedArticle.content">
                </div>

            </div>

        </div>

        <!-- CTA -->

        <div
            class=" max-w-3xl mx-auto mt-12 bg-[#FAF7FF] rounded-[24px] p-8 ">

            <p class="text-xs uppercase tracking-[2px] text-[#8C52FF]">

                NRI PROPERTY ADVISORY

            </p>

            <h3
            class="mt-3 text-2xl">

                Need personalised guidance?

            </h3>

            <p
            class="mb-6 text-[#595959]">

                Speak with a CircledPlus advisor and receive
                a curated shortlist aligned to your goals.

            </p>

            <a routerLink="/contactus" class="theme-btn1 font-semibold py-3 px-10 text-white rounded-full text-[10px] md:text-sm whitespace-nowrap shadow-lg transition-transform active:scale-95 shrink-0">

                Contact Us

            </a>

            </div>

    </div>

    </div>
}



<!-- Overlay -->
<div *ngIf="isExpertModalOpen"
     class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">

  <!-- Modal card -->
  <div class="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-6 relative">

    <!-- Close -->
    <button (click)="closeExpertModal()"
      class="absolute right-4 top-4 text-gray-400 hover:text-black text-xl">✕</button>

    <!-- FORM VIEW -->
    <div *ngIf="!isFormSubmitted">

      <h2 class="text-2xl font-bold mb-1">Talk to an Expert</h2>
      <p class="text-gray-500 mb-6">We will contact you shortly.</p>

      <form [formGroup]="expertForm" (ngSubmit)="submitExpertForm()" class="space-y-4">

        <!-- Full Name -->
        <div>
          <input
            type="text"
            formControlName="name"
            placeholder="Full Name"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['name'].invalid && f['name'].touched">
          <p *ngIf="f['name'].invalid && f['name'].touched" class="text-red-500 text-xs mt-1">
            Full name is required.
          </p>
        </div>
      
        <!-- Email -->
        <div>
          <input
            type="email"
            formControlName="email"
            placeholder="Email Address"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['email'].invalid && f['email'].touched">
          <p *ngIf="f['email'].errors?.['required'] && f['email'].touched" class="text-red-500 text-xs mt-1">
            Email is required.
          </p>
          <p *ngIf="f['email'].errors?.['email'] && f['email'].touched" class="text-red-500 text-xs mt-1">
            Please enter a valid email address.
          </p>
        </div>
      
        <!-- Mobile -->
        <div>
          <input
            type="tel"
            formControlName="mobile"
            placeholder="Mobile Number"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['mobile'].invalid && f['mobile'].touched">
          <p *ngIf="f['mobile'].errors?.['required'] && f['mobile'].touched" class="text-red-500 text-xs mt-1">
            Mobile number is required.
          </p>
          <p *ngIf="f['mobile'].errors?.['pattern'] && f['mobile'].touched" class="text-red-500 text-xs mt-1">
            Please enter a valid 10-digit mobile number.
          </p>
        </div>
      
        <!-- Message -->
        <div>
          <textarea
            rows="4"
            formControlName="message"
            placeholder="What are you looking for?"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['message'].invalid && f['message'].touched">
          </textarea>
          <p *ngIf="f['message'].invalid && f['message'].touched" class="text-red-500 text-xs mt-1">
            Message is required.
          </p>
        </div>
      
        <!-- Submit -->
        <button
          type="submit"
          [disabled]="expertForm.invalid"
          class="w-full bg-[#8B5CF6] text-white py-3 rounded-full font-semibold hover:bg-[#7C3AED] disabled:opacity-50">
          Submit Request
        </button>
      
      </form>
    </div>

    <!-- SUCCESS VIEW -->
    <div *ngIf="isFormSubmitted" class="text-center py-10">
      <div class="text-5xl mb-4">✅</div>
      <h3 class="text-2xl font-bold mb-2">Request Sent!</h3>
      <p class="text-gray-500 mb-6">Our expert will contact you soon.</p>

      <button (click)="closeExpertModal()"
        class="bg-blue-600 text-white px-6 py-2 rounded-full">
        Close
      </button>
    </div>

  </div>
</div>
